import { createAsyncThunk } from '@reduxjs/toolkit'
import { Fail, Success } from 'store/types'
import callAPI from 'api'
import {
  GetNotificationResponse,
  GetNotificationCountResponse,
  NotificationPayload,
  UpdateNotificationStatusPayload,
  NotificationsCountResponse,
} from './types/notification'

/**
 * Async thunk to fetch master
 */

// TODO: can be removed once useGetNotifications hooks working is confirmed.
export const getNotifications = createAsyncThunk<Fail | Success<GetNotificationResponse>, NotificationPayload>(
  'notification/get_notification',
  async (payload) =>
    await callAPI<GetNotificationResponse, NotificationPayload>('crm_get_notification', [payload], {
      requireAuthorization: true,
    }),
)

export const getUnReadNotificationCount = createAsyncThunk<Fail | Success<GetNotificationCountResponse>>(
  'notification/get_unread_notification_count',
  async () =>
    await callAPI<GetNotificationCountResponse>('crm_get_unread_notification_count', undefined, {
      requireAuthorization: true,
    }),
)

export const readAllNotifications = createAsyncThunk(
  'notification/read_all_notification',
  async (payload: () => void) => {
    const result = await callAPI<{ success: boolean }>('crm_read_all_notification', undefined, {
      requireAuthorization: true,
    })
    if (result.status === 'SUCCESS') {
      payload()
    }
    return result
  },
)

export const updateNotificationStatus = createAsyncThunk(
  'notification/update_notification_status',
  async (payload: UpdateNotificationStatusPayload) => {
    const result = await callAPI<{ success: boolean }>(
      'crm_update_notification_status',
      [{ notification_id: payload.notification_id, seen: payload.seen }],
      {
        requireAuthorization: true,
        reloadOnReauth: false,
      },
    )
    if (result.status === 'SUCCESS') {
      payload.onNotiStatUpdateCallBack()
    }
    return result
  },
)

export const getNotificationsCount = async () =>
  await callAPI<NotificationsCountResponse>('crm_get_notifications_count', [], {
    requireAuthorization: true,
  })

export const getNotifications_ = async (payload: NotificationPayload) =>
  await callAPI<GetNotificationResponse, NotificationPayload>('crm_get_notification', [payload], {
    requireAuthorization: true,
  })
